module.exports = __webpack_public_path__ + "assets/img/err@2x.34d5d029.png";